import { render } from "./StoryTestimonial.vue?vue&type=template&id=0c315c66&scoped=true"
import script from "./StoryTestimonial.vue?vue&type=script&lang=js"
export * from "./StoryTestimonial.vue?vue&type=script&lang=js"

import "./StoryTestimonial.vue?vue&type=style&index=0&id=0c315c66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c315c66"

export default script